module.exports = __webpack_public_path__ + "static/media/downRightArrow.482e1474.svg";